// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"490":"1f722ecd94468cfd","537":"f1c232cc8280b9c7"}[chunkId] + ".js";
};